// An eBay return step's state before Process and its partly-done checklist
// (2026-10-29, docs/decisions/2026-10-29-ebay-return-state-before-approve.md).
// The checklist lines are the return-label wait's shape
// ({ key, state, label, id?, detail?, error? }; @cxhub/shared's
// return-label-pending.js), shown by the same component
// (ReturnLabelPending.jsx's PendingStepChecklist). Pure: no calls.

export const PARTLY_DONE_STEP_STATE = 'partly_done'

// The step states a reload restores: a return step left partly done (its
// newest saved progress names the piece that failed) shows ✕ with its
// checklist and keeps Process, which resumes. A step whose newest progress
// is done, or has no saved progress, is left as it is.
export function partlyDoneStepStates(suggestion) {
  const calls = suggestion?.modelMeta?.apiCalls ?? []
  const newest = {}
  for (const c of calls) {
    if (!Number.isInteger(c?.stepIndex) || !c?.stepProgress) continue
    newest[c.stepIndex] = c.stepProgress
  }
  const states = {}
  for (const [k, p] of Object.entries(newest)) {
    if (!p?.failed) continue
    states[k] = { status: 'failed', result: null, partlyDone: true, stepState: PARTLY_DONE_STEP_STATE, checklist: Array.isArray(p.checklist) ? p.checklist : [], error: `Partly done: ${p.failed.error ?? 'a later piece failed'}. Process again finishes from there, with no second RMA or label.` }
  }
  return states
}

// The step card's line before Process: what eBay shows and what Process will
// do (the grounding's snapshot, params.ebayReturnState.text). Only on the
// steps that approve an eBay return.
const STATE_LINE_TYPES = new Set(['process_return_refund', 'issue_ebay_return_refund'])
export function ebayReturnStateLine(action) {
  if (!STATE_LINE_TYPES.has(action?.type)) return null
  const text = action?.params?.ebayReturnState?.text
  return typeof text === 'string' && text.trim() ? text : null
}

// The order note step that takes the RMA line when eBay had approved the
// return itself (result.rmaNoteLine): the first add_order_note after the
// return step, else -1.
export function rmaNoteSiblingIndex(actions, index) {
  const list = Array.isArray(actions) ? actions : []
  for (let k = index + 1; k < list.length; k++) if (list[k]?.type === 'add_order_note') return k
  return -1
}

// The note with the RMA line added once (at the start).
export function withRmaNoteLine(note, line) {
  const text = String(note ?? '')
  if (!line || text.includes(line)) return text
  return text.trim() ? `${line} ${text}` : line
}
